// extracted by mini-css-extract-plugin
export default {"error":"FormSelect_error__HSbzp","placeholder":"FormSelect_placeholder__QGs0J"};